export const storageAreaConstants = {
    GETALL_REQUEST: 'STORAGEAREA_GETALL_REQUEST',
    GETALL_SUCCESS: 'STORAGEAREA_GETALL_SUCCESS',
    GETALL_FAILURE: 'STORAGEAREA_GETALL_FAILURE',

    GET_REQUEST: 'STORAGEAREA_GET_REQUEST',
    GET_SUCCESS: 'STORAGEAREA_GET_SUCCESS',
    GET_FAILURE: 'STORAGEAREA_GET_FAILURE',

    ADD_REQUEST: 'STORAGEAREA_ADD_REQUEST',
    ADD_SUCCESS: 'STORAGEAREA_ADD_SUCCESS',
    ADD_FAILURE: 'STORAGEAREA_ADD_FAILURE',

    UPDATE_REQUEST: 'STORAGEAREA_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'STORAGEAREA_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'STORAGEAREA_UPDATE_FAILURE',

    DELETE_REQUEST: 'STORAGEAREA_DELETE_REQUEST',
    DELETE_SUCCESS: 'STORAGEAREA_DELETE_SUCCESS',
    DELETE_FAILURE: 'STORAGEAREA_DELETE_FAILURE',
    
    COUNT_REQUEST: 'STORAGEAREA_COUNT_REQUEST',
    COUNT_SUCCESS: 'STORAGEAREA_COUNT_SUCCESS',
    COUNT_FAILURE: 'STORAGEAREA_COUNT_FAILURE',

};